import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, throwError } from 'rxjs';
import { AlertService } from '../services/alert.service';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const alert = inject(AlertService);
  const router = inject(Router);

  const isServiceCall =
    (req.url.includes('/payment/payout') ||
      req.url.includes('/payment/collection')) &&
    req.method === 'POST';

  const isContactUsCall = req.url.includes('onboarding/v1/customer-request') && req.method === 'POST';

  const isServiceConfig =
    req.url.includes('/configurations/v1/bank') && req.method === 'GET';

  if (isServiceCall) {
    return auth.getServiceAccountToken().pipe(
      switchMap((token) => {
        const cloned = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });

        return next(cloned);
      }),
    );
  }

  if (isServiceConfig || isContactUsCall) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: ``,
      },
    });

    return next(cloned);
  }

  const token = auth.getAccessToken();

  const cloned = token
    ? req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    : req;

  return next(cloned).pipe(
    catchError((error: HttpErrorResponse) => {
      const isLoginPage = router.url === '/login';

      if (!isLoginPage && error.status === 401) {
        alert.toastError(
          'Session Expired',
          'Your login session has expired. Please login again.',
        );

        setTimeout(() => {
          auth.logout().subscribe({
            next: () => {
              auth.clearSession();
              router.navigate(['/login']);
            },
            error: () => {
              auth.clearSession();
              router.navigate(['/login']);
            },
          });
        }, 2000);
      }

      return throwError(() => error);
    }),
  );
};
